import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { ListGroup, ListGroupItem } from 'reactstrap';

import Filters from 'components/filters';
import Feature from 'components/feature';
import PriceChanges from 'components/priceChanges';
import { useMarketData } from 'context/market';

import { formatCurrency } from './MarketCharts.helpers';
import { CHART_TYPES } from './MarketCharts.constants';
import {
  filters,
  marketDataItem,
  marketDataItemActive,
} from './scss/MarketCharts.module.scss';

const MarketChartsFilters = ({ selectedProduct, onProductSelect }) => {
  const { marketIndices } = useMarketData();
  useEffect(() => {
    if (isEmpty(selectedProduct)) {
      onProductSelect(marketIndices[0]);
    }
  });

  return (
    <>
      <Feature>
        <Filters options={CHART_TYPES} theme="light" className={filters} />
      </Feature>
      <ListGroup flush>
        {marketIndices.map((item, index) => {
          const itemClassName = classNames(marketDataItem, {
            [marketDataItemActive]:
              item.commodity === selectedProduct.commodity,
          });
          return (
            <ListGroupItem
              tag="button"
              key={`${item.commodity}-${index}`}
              className={itemClassName}
              onClick={() => onProductSelect(item)}
              onFocus={() => onProductSelect(item)}
            >
              <p>{item.commodity}</p>
              <div>
                <p>{formatCurrency(item.marketPrice)}</p>
                <PriceChanges
                  changes={item.changePercentage}
                  changeType={item.type}
                />
              </div>
            </ListGroupItem>
          );
        })}
      </ListGroup>
    </>
  );
};

MarketChartsFilters.propTypes = {
  selectedProduct: PropTypes.shape({}),
  onProductSelect: PropTypes.func.isRequired,
};

MarketChartsFilters.defaultProps = {
  selectedProduct: {},
};

export default MarketChartsFilters;
